<template>
  <div class="add-equipment">
    <el-row :gutter="16">
      <el-col :span="12">
        <div class="panel">
          <div class="panel-header">
            <div class="title">{{ $t("cAdvertPiano.selectSb", [selectedList.length]) }}</div>
            <div class="actions">
              <el-button
                type="text"
                icon="el-icon-delete"
                :disabled="selectedList.length === 0"
                @click="clearSelected"
                style="color: #409eff"
                v-hasPerm="['advert:piano:edit']"
                >{{ $t("searchLoginInfo.clear") }}</el-button
              >
            </div>
          </div>
          <el-scrollbar class="panel-body" :wrap-style="{ maxHeight: bodyMaxHeight }">
            <div v-for="g in selectedList" :key="g.id" class="group-card selected">
              <div class="left">
                <div class="name">{{ g.name }}</div>
              </div>
              <div class="right">
                <el-button type="text" @click="removeGroup(g)">{{ $t("advertGroupRela.remove") }}</el-button>
              </div>
            </div>
          </el-scrollbar>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="panel">
          <div class="panel-header">
            <div class="title">{{ $t("cAdvertPiano.allSb") }}</div>
          </div>
          <div
            class="panel-body el-scrollbar scrollbar"
            v-infinite-scroll="load"
            :infinite-scroll-disabled="loading || noMore"
          >
            <div v-for="g in equipment" :key="g.id" class="group-card" :class="{ active: isSelected(g.id) }">
              <div class="left">
                <div class="name">{{ g.name }}</div>
              </div>
              <div class="right">
                <el-button
                  v-if="isSelected(g.id)"
                  type="danger"
                  size="mini"
                  icon="el-icon-delete"
                  @click="removeGroup(g)"
                  >{{ $t("advertGroupRela.remove") }}</el-button
                >
                <el-button v-else type="primary" size="mini" icon="el-icon-plus" @click="addGroup(g)">
                  {{ $t("advertGroupRela.add") }}
                </el-button>
              </div>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  export default {
    name: "AddEquipment",
    props: {
      value: {
        type: Array,
        default: () => []
      },
      maxBodyHeight: {
        type: String,
        default: "300px"
      }
    },
    data() {
      return {
        equipment: [],
        loading: false,
        noMore: false,
        pages: {
          pageSize: 10,
          pageIndex: 1,
          total: 0
        }
      };
    },
    computed: {
      bodyMaxHeight() {
        return this.maxBodyHeight;
      },
      selectedIds() {
        return Array.isArray(this.value) ? this.value.slice() : [];
      },
      selectedList() {
        const map = new Set(this.selectedIds);
        return this.equipment.filter(g => map.has(g.id));
      }
      // filteredGroups() {
      //   const k = this.keyword.trim().toLowerCase();
      //   if (!k) return this.equipment;
      //   return this.equipment.filter(g => (g.name || "").toLowerCase().includes(k));
      // }
    },

    methods: {
      getEquipmentList() {
        if (this.loading || this.noMore) return;
        this.loading = true;
        this.$api
          .request(this.$url.AdvertsPiano.equipment, this.$method.get, {
            pageIndex: this.pages.pageIndex,
            pageSize: this.pages.pageSize
          })
          .then(res => {
            if (res.code === 0) {
              const records = res.data.records.map(record => ({
                id: record.id,
                name: record.equipmentName
              }));
              this.equipment = this.pages.pageIndex === 1 ? records : [...this.equipment, ...records];
              this.pages.total = res.data.total;
              this.noMore = this.equipment.length >= this.pages.total;
              this.pages.pageIndex++;
            }
          })
          .finally(() => {
            this.loading = false;
          });
      },
      load() {
        this.getEquipmentList();
      },
      isSelected(id) {
        return this.selectedIds.includes(id);
      },
      addGroup(g) {
        if (!this.isSelected(g.id)) {
          const next = this.selectedIds.concat([g.id]);
          this.$emit("input", next);
          this.$emit("change", next);
        }
      },
      removeGroup(g) {
        const next = this.selectedIds.filter(id => id !== g.id);
        this.$emit("input", next);
        this.$emit("change", next);
      },
      clearSelected() {
        this.$emit("input", []);
        this.$emit("change", []);
      }
    },
    mounted() {
      this.getEquipmentList();
    }
  };
</script>

<style lang="scss" scoped>
  .add-equipment {
    .panel {
      background: #f5f7fa;
      border-radius: 6px;
      padding: 12px;
      box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
      .panel-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 8px;
        height: 40px;
        .title {
          font-weight: 600;
        }
        .search {
          width: 220px;
        }
      }
      .panel-body {
        .empty {
          color: #999;
          text-align: center;
          padding: 32px 0;
        }
        .group-card {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 10px 12px;
          border-radius: 6px;
          background: #fff;
          border: 1px solid #f5f7fa;
          margin-bottom: 10px;
          color: #5a5a5a;
          .left {
            .name {
              font-weight: 600;
              margin-bottom: 4px;
            }
            .meta {
              font-size: 12px;
              color: #909399;
            }
          }
        }
        .group-card.active {
          border: 1px solid #f5d4d7;
          background: #fef0f0;
        }
        .group-card.selected {
          color: #2b6cf6;
          background: #f0f9ff;
          border: 1px solid #abdd9c;
        }
      }
    }
    .scrollbar {
      max-height: 400px;
      overflow: auto;
    }
  }
</style>
